import { requireField } from './validators';
import IncidentParticipant from './IncidentParticipant';
import IncidentDocument from './IncidentDocument';

export default class IncidentReport {
  constructor(data = {}) {
    requireField(data.type, 'incident.type');
    requireField(data.date, 'incident.date');

    this.id = data.id || `inc-${Math.random().toString(36).slice(2, 9)}`;
    this.type = data.type;
    this.date = data.date;
    this.reportedBy = data.reportedBy || '';
    this.description = data.description || '';
    this.severity = data.severity || 'medium';
    this.status = data.status || 'open';
    this.assignedKeyWorker = data.assignedKeyWorker || '';
    this.followUpRequired = Boolean(data.followUpRequired);
    this.followUpDate = data.followUpDate || null;
    this.followUpPrompt = data.followUpPrompt || '';
    this.participants = (data.participants || [])
      .filter((p) => p && p.id && p.type)
      .map((p) => new IncidentParticipant(p));
    this.inventoryItemIds = data.inventoryItemIds || [];
    this.documents = (data.documents || []).map((d) => new IncidentDocument(d));
    this.createdBy = data.createdBy || data.reportedBy || 'System';
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || this.createdAt;
  }

  toJSON() {
    return {
      ...this,
      participants: this.participants.map((p) => p.toJSON()),
      documents: this.documents.map((d) => d.toJSON())
    };
  }
}
